import { CalendarInput, type DateRange } from '@nexelem/components';
import { useController } from 'react-hook-form';

type FormCalendarRangeInputProps = {
  name: string;
  label: string;
  required?: boolean;
  className?: string;
};

export const FormCalendarRangeInput = ({ name, label, required, className }: FormCalendarRangeInputProps) => {
  const {
    field: { onChange, value, ...field },
  } = useController({ name });

  const onSelect = (selected?: DateRange) => {
    onChange(selected);
  };

  return (
    <CalendarInput
      className={className}
      label={label}
      mode="range"
      required={required}
      selected={value}
      onSelect={onSelect}
      {...field}
    />
  );
};
